export default {
  loadFamilyHeight() {
    let height = 0;
    $('.js-family-height.collapsed')
      .parents('.js-family-container-height')
      .css('min-height', '')
      .each(function() {
        if (height < $(this).outerHeight()) {
          height = $(this).outerHeight();
        }
      }).css('min-height', height);
  },
  loadHoverFamily() {
    $('.js-family-container-height')
      .hover(function() {
        $(this).find('.collapse').collapse('show');
        $(this).find('.js-family-height').addClass('collapsed');
      }, function() {
        $('.js-family-container-height').find('.collapse').removeClass('show');
        $('.js-family-container-height').find('.js-family-height').removeClass('collapsed');
      });
  },
}



// WEBPACK FOOTER //
// ./scripts/util/carto.js